// Copyright 2022 Amazon.com, Inc. or its affiliates. All Rights Reserved.

import { getAuthType } from "../../../configurations";
import { AuthType } from "../../../enums";
import { AuthStrategy } from "../../../types";
import { CognitoAuthStrategy } from "../cognito/CognitoAuthStrategy";
import { SSOAuthStrategy } from "../sso/SSOAuthStrategy";

const SignOut = (): JSX.Element | null => {
  const authType = getAuthType();

  let authStrategy: AuthStrategy;
  switch (authType) {
    case AuthType.STANDARD: {
      authStrategy = new CognitoAuthStrategy();
      break;
    }
    case AuthType.IAM_IDENTITY_CENTER: {
      authStrategy = new SSOAuthStrategy();
      break;
    }
  }

  return authStrategy.signOut();
};

export default SignOut;
